export default __webpack_public_path__ + "19456030fea49d80ded80337772e8ae3.svg";